import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'custom-toast',
  standalone: false,
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss',
})
export class CustomToastComponent extends Toast {}
